"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfResetPasswordDto = instanceOfResetPasswordDto;
exports.ResetPasswordDtoFromJSON = ResetPasswordDtoFromJSON;
exports.ResetPasswordDtoFromJSONTyped = ResetPasswordDtoFromJSONTyped;
exports.ResetPasswordDtoToJSON = ResetPasswordDtoToJSON;
exports.ResetPasswordDtoToJSONTyped = ResetPasswordDtoToJSONTyped;
/**
 * Check if a given object implements the ResetPasswordDto interface.
 */
function instanceOfResetPasswordDto(value) {
    if (!('token' in value) || value['token'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('confirmPassword' in value) || value['confirmPassword'] === undefined)
        return false;
    return true;
}
function ResetPasswordDtoFromJSON(json) {
    return ResetPasswordDtoFromJSONTyped(json, false);
}
function ResetPasswordDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'],
        'password': json['password'],
        'confirmPassword': json['confirmPassword'],
    };
}
function ResetPasswordDtoToJSON(json) {
    return ResetPasswordDtoToJSONTyped(json, false);
}
function ResetPasswordDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'token': value['token'],
        'password': value['password'],
        'confirmPassword': value['confirmPassword'],
    };
}
